export const getStartAndEndDate = (
  selectedDate: Date | string,
  selectedSegment: "year" | "month" | "day",
) => {
  let startDate, endDate;

  // Parse the date ensuring we use local timezone consistently
  const date = new Date(selectedDate);

  // Get year, month, day from the date object
  // If the selectedDate is already a Date object, this will preserve the values
  // If it's a string, this will parse it correctly
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  switch (selectedSegment) {
    case "year":
      // Create start and end dates for the entire year
      startDate = new Date(year, 0, 1, 0, 0, 0, 0); // January 1st at midnight
      endDate = new Date(year, 11, 31, 23, 59, 59, 999); // December 31st at 23:59:59.999
      break;
    case "month":
      // Create start and end dates for the entire month
      startDate = new Date(year, month, 1, 0, 0, 0, 0); // 1st day of month at midnight
      endDate = new Date(year, month + 1, 0, 23, 59, 59, 999); // Last day of month at 23:59:59.999
      break;
    case "day":
      // Create start and end dates for the entire day
      startDate = new Date(year, month, day, 0, 0, 0, 0); // Start of the day at midnight
      endDate = new Date(year, month, day, 23, 59, 59, 999); // End of the day at 23:59:59.999
      break;
    default:
      throw new Error(
        'Invalid selectedSegment, must be "year", "month", or "day"',
      );
  }

  return { startDate, endDate };
};
